import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Validacion';

export interface Validaciones {
	idTipo: string;
}

export interface ImportacionesLogDetalle {
	idImportacion: number;
}

export interface MaestroValidaciones {
	Año: number;
	Tasa_IS_Matriz: number;
    Tasa_GtosGrales: number;
}

export class ValidacionesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarValidaciones(data:Validaciones): AxiosPromise<any> {
		return this.cliente.post(data, `/ListarValidaciones`);
	}

	ValidarInvalidar(data: any): AxiosPromise<any> {
		return this.cliente.post(data, `/ValidarInvalidar`);
	}
	
	ComprobarValidarInvalidar(data: any): AxiosPromise<any> {
		return this.cliente.post(data, `/ComprobarValidar`);
	}

	ListarMaestroValidaciones(): AxiosPromise<any> {
		return this.cliente.get(`/ListarMaestroValidaciones`);
	}

	CrearMaestroValidacion(data: any): AxiosPromise<any> {
		return this.cliente.post(data, `/CrearMaestroValidacion`);
	}

	EliminarValidacion(año:Number): AxiosPromise<any> {
		return this.cliente.remove(año, `/EliminarValidacion`);
	}

	ModificarValidacion(añoOLD:Number,validacion: any): AxiosPromise<any[]> {
		return this.cliente.put(añoOLD, validacion, `/ModificarMaestroValidacion`);
	}
}